import CssBaseline from '@mui/material/CssBaseline';
import {Paper, Button, Typography, Box, Stack, Link, styled} from '@mui/material';
import Grid from '@mui/material/Grid2';

import {OptimizeIcon} from 'styles/icons';
import SignInImage from 'assets/images/signin_image.png';

import {useAuth0} from '@auth0/auth0-react';

import {useLocation} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {URLPathname} from 'interfaces';

const SignInView = () => {
  const {t} = useTranslation('common');

  const {loginWithRedirect} = useAuth0();
  const {pathname, search} = useLocation();
  const urlParams = new URLSearchParams(search.substring(1));

  urlParams.has('error') && alert(urlParams.get('error_description'));

  return (
    <Root container className={classes.root}>
      <CssBaseline />
      <Grid size={{xs: 12, sm: 8, md: 5}} component={Paper} elevation={0} square>
        <Stack direction="column" justifyContent="space-evenly" alignItems="center" spacing={2} sx={{height: '100vh'}}>
          <Stack direction="row" justifyContent="center" alignItems="center" spacing={2}>
            <OptimizeIcon className={classes.logoIcon} />
            <div className={classes.logoFont}>{t('bioplan')}</div>
          </Stack>
          <Stack justifyContent="center" alignItems="center" spacing={1}>
            <Typography component="h1" variant="h4" align="right">
              {t('startPlanning')}
            </Typography>
            <Typography variant="body1" color="textSecondary" align="right">
              {t('SignInToBioPlanMessage')}
            </Typography>
            <Box py={5}>
              <Button
                variant="contained"
                size="large"
                onClick={async () => {
                  await loginWithRedirect({
                    appState: {targetUrl: pathname},
                  });
                }}
                data-testid="login-button"
                sx={{fontSize: 24, width: 240}}
              >
                {t('logIn')}
              </Button>
            </Box>
          </Stack>

          <Stack direction="row" spacing={2}>
            <Link href={URLPathname.privacyPolicy} sx={{textTransform: 'capitalize'}}>
              {t('privacy')}
            </Link>
            <Link href={URLPathname.termsofService} sx={{textTransform: 'capitalize'}}>
              {t('terms')}
            </Link>
          </Stack>
        </Stack>
      </Grid>
      <Grid size={{sm: 4, md: 7, xs: false}} className={classes.image} />
    </Root>
  );
};

export default SignInView;

const PREFIX = 'RootGrid';
const classes = {
  root: `${PREFIX}-root`,
  image: `${PREFIX}-image`,
  logoIcon: `${PREFIX}-logoIcon`,
  logoFont: `${PREFIX}-logoFont`,
};
const Root = styled(Grid)(({theme}) => ({
  [`&.${classes.root}`]: {
    height: '100vh',
  },
  [`& .${classes.image}`]: {
    backgroundImage: `url(${SignInImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  [`& .${classes.logoIcon}`]: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    color: theme.palette.primary.main,
  },
  [`& .${classes.logoFont}`]: {
    marginLeft: theme.spacing(1.2),
    fontSize: theme.spacing(4.5),
    lineHeight: theme.spacing(0.15),
    letterSpacing: theme.spacing(-0.17),
    color: theme.palette.text.secondary,
  },
}));
